import styled from '@emotion/styled/macro';

export default styled.p`
	font-family: 'Roboto';
	font-size: 20px;
	font-weight: 300;
	line-height: 1.5;
	color: var(--warm-grey);
`;
